import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { Active } from "../../../../model/filters/active";
import { Router } from "@angular/router";

@Component({
  selector: "active-form",
  templateUrl: "./active-form.component.html",
  styleUrls: ["./active-form.component.css"],
})
export class ActiveFormComponent {
  @Input() filter: Active = new Active();
  @Output() applyFilter = new EventEmitter<Active>();

  formVisible: boolean = true;
  activeFilter: Active = new Active();

  constructor(private router: Router) {}

  apply(): void {
    const filter = new Active();

    this.applyFilter.emit(filter);
    this.formVisible = false;
  }
}
